var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76588 10.9827C8.86239 9.93961 9.69543 9.11779 10.7386 9.02788C15.0269 8.65829 18.0044 8.65722 22.2583 9.0256C23.3066 9.11639 24.1407 9.94647 24.2335 10.9951C24.6079 15.2276 24.5734 18.2161 24.2203 22.484C24.1326 23.5444 23.2928 24.3889 22.2331 24.4787C17.9667 24.8405 14.9928 24.8397 10.7808 24.4805C9.71856 24.3899 8.87877 23.5409 8.792 22.4778C8.44716 18.253 8.37042 15.2572 8.76588 10.9827Z",
    stroke: "#23cbd8",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.25V10.75",
    stroke: "#23cbd8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 7.25V10.75",
    stroke: "#23cbd8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.75H24",
    stroke: "#23cbd8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.25H12.51",
    stroke: "#23cbd8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20.75H12.51",
    stroke: "#23cbd8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5098 17.25H16.5198",
    stroke: "#23cbd8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5098 20.75H16.5198",
    stroke: "#23cbd8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.52 17.25H20.53",
    stroke: "#23cbd8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.52 20.75H20.53",
    stroke: "#23cbd8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar32);
export default __webpack_public_path__ + "static/media/calendar-32.d1c135f6f2b2b076f4f4671f2bb4725f.svg";
export { ForwardRef as ReactComponent };